import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { initAnalytics, resetPageDedupe, trackEvent, trackPageView } from "@/lib/analytics";

export const AnalyticsTracker = () => {
  const location = useLocation();

  useEffect(() => {
    initAnalytics();
    const onClick = (e: MouseEvent) => {
      const a = (e.target as HTMLElement | null)?.closest?.("a[href]") as HTMLAnchorElement | null;
      if (!a) return;
      const href = a.getAttribute("href") ?? "";
      // No phone number or address is sent — only the page where the click happened.
      if (href.startsWith("tel:")) trackEvent("click_phone", { page_path: window.location.pathname });
      else if (href.startsWith("mailto:")) trackEvent("click_email", { page_path: window.location.pathname });
    };
    document.addEventListener("click", onClick, true);
    return () => document.removeEventListener("click", onClick, true);
  }, []);

  useEffect(() => {
    // location.key changes on every real navigation (incl. returning to a page); query string
    // is excluded from page_path so prefilled form text never reaches Google.
    resetPageDedupe();
    const t = setTimeout(() => trackPageView(location.pathname), 50);
    return () => clearTimeout(t);
  }, [location.key, location.pathname]);

  return null;
};
